import { render, staticRenderFns } from "./logoTop.vue?vue&type=template&id=054d81a2&"
import script from "./logoTop.vue?vue&type=script&lang=js&"
export * from "./logoTop.vue?vue&type=script&lang=js&"
import style0 from "./logoTop.vue?vue&type=style&index=0&id=054d81a2&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports